// import { isTypedArray } from 'lodash'
// import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'
import request from '@/utils/request'

// const baseURL = process.env.VUE_APP_BASE_URL

// 新增创新主体
export function addInnovation(data) {
  return request({
    url: '/bus/innovation/insert',
    method: 'POST',
    data
  })
}
// 删除创新主体
export function deleteInnovation(data) {
  return request({
    url: '/bus/innovation/delete',
    method: 'POST',
    data
  })
}
// 发布下架创新主体
export function statusInnovation(data) {
  return request({
    url: '/bus/innovation/status',
    method: 'POST',
    data
  })
}
// 发布下架创新主体
export function allList() {
  return request({
    url: '/bus/innovation/list',
    method: 'GET'
  })
}
